if (typeof loadeMoreSlider_G === "undefined") {
  globalThis.loadeMoreSlider_G = null;
}

(function () {
  const initSlider = () => {
    const sliders = document.querySelectorAll(".product-card-js");
    const dir = document.querySelector("html").getAttribute("dir");

    let nextSel = ".product-button-group .swiper-button-next";
    let prevSel = ".product-button-group .swiper-button-prev";
    if (dir === "rtl") {
      [nextSel, prevSel] = [prevSel, nextSel];
    }
    sliders.forEach((slider, index) => {
      if (slider?.swiper) return;

      const slideCount = slider.querySelectorAll(".swiper-slide").length;
      const speed = slideCount > 30 ? 0 : 800;

      // Los controles se resuelven **dentro de esta tarjeta**, no como string.
      // Con `uniqueNavElements` (default true) Swiper busca el selector en todo
      // el documento y sólo lo acota al contenedor cuando encuentra exactamente
      // uno adentro: una tarjeta impresa sin flechas (una sección con
      // `show_card_arrows` apagado) se quedaba con la lista completa del
      // documento, o sea que cualquier flecha de la página movía su galería.
      const nextEl = slider.querySelector(nextSel);
      const prevEl = slider.querySelector(prevSel);
      const paginationEl = slider.querySelector(
        ".product-pagination .swiper-pagination"
      );

      const productSlider = new Swiper(slider, {
        speed: speed,
        pagination: {
          el: paginationEl,
          clickable: true,
        },
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl,
        },
        allowTouchMove: true,
        990: {
          allowTouchMove: false,
        },
      });
    });
  };

  initSlider();
  loadeMoreSlider_G = initSlider;

  document.addEventListener("shopify:section:load", function () {
    initSlider();
  });
})();
